<template>
  <div
    class="elevation-12"
    style="
    width:330px;
    position: fixed;
    right: 0;
    z-index: 15;
    max-height: calc(100% - 65px);
    overflow-y: auto;
    overflow-x: hidden;

"
  >
    <v-expansion-panels>
      <v-expansion-panel :key="0" expand-icon="fa-arrow-alt-circle-down">
        <v-expansion-panel-header>
          <div>
            <h2 style="margin-right: 15px">
              <span class="ml-2 hidden-xs-only">{{ $t("templateList.documentTemplates") }} ({{ templateList.length }})</span>
              <span class="ml-2 hidden-sm-and-up">{{ $t("templateList.documentTemplates") }}</span>
            </h2>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="pb-3" style="max-height: 450px">
            <div v-if="templateList.length === 0">
              {{ $t("global.noData") }}
            </div>
            <div v-for="template in templateList" :key="template.id" class="text-no-wrap">
              <v-row class="ma-0">
                <v-tooltip top z-index="500">
                  <template #activator="{on}">
                    <div class="pt-3" style="max-width: 152px" v-on="on">
                      {{ template.name }}
                    </div>
                  </template>
                  {{ $t("global.createdAt") }} {{ template.createdAt }} {{ $t("global.by") }} {{ template.createdByName }}
                </v-tooltip>
                <v-spacer />
                <div class="py-2">
                  <v-tooltip top v-if="template.owner" z-index="500">
                    <template #activator="{on}">
                      <v-btn @click="remove(template)" class="mx-0" icon v-on="on" small>
                        <v-icon>fa-minus-circle</v-icon>
                      </v-btn>
                    </template>
                    {{ $t("global.delete") }}
                  </v-tooltip>
                  <v-tooltip top v-if="template.owner" z-index="500">
                    <template #activator="{on}">
                      <v-btn :disabled="$store.getters['Ajax/loading']" @click="openSaveDialog(template)" class="mx-0" icon v-on="on" small>
                        <v-icon>fa-save</v-icon>
                      </v-btn>
                    </template>
                    {{ $t("global.save") }}
                  </v-tooltip>
                  <v-tooltip top z-index="500">
                    <template #activator="{on}">
                      <v-btn @click="load(template)" class="mx-0" icon v-on="on" small v-if="canViewLoadButton">
                        <v-icon>fa-file-download</v-icon>
                      </v-btn>
                    </template>
                    {{ $t("templateList.loadTemplate") }}
                  </v-tooltip>
                </div>
              </v-row>
              <v-divider class="mb-1" />
            </div>
          </div>
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="openSaveDialog(null)" class="primary" style="width: 285px">{{
            $t("templateList.newTemplateButton")
          }}</v-btn>
          <v-dialog max-width="290" persistent v-model="dialog">
            <v-card>
              <v-card-title class="headline">
                {{ dialogValues.id == null ? $t("templateList.newTemplateDialog.title") : $t("templateList.newTemplateDialog.titleEdit") }}
              </v-card-title>
              <v-card-text>
                {{ $t("templateList.newTemplateDialog.content") }}
                <v-text-field :label="$t('templateList.newTemplateDialog.name')" v-model="dialogValues.name" />
                <v-checkbox :label="$t('global.public')" v-model="dialogValues.public" />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="save()" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { documentTypeEnum } from "../staticData/DocumentNumberTemplate";

export default {
  name: "TemplateList",
  props: {
    documentType: {
      required: true,
      type: Number
    },
    value: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    templateList: [],
    dialog: false,
    dialogValues: {
      id: null,
      name: "",
      public: 0
    }
  }),
  computed: {
    canViewLoadButton() {
      if (this.documentType === documentTypeEnum.DOCUMENT_TYPE_DELEGATION_ORDER && this.$store.state.DelegationOrder.readonly === true) {
        return false;
      }
      if (this.documentType === documentTypeEnum.DOCUMENT_TYPE_DELEGATION && this.$store.state.Delegation.readonly === true) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.downloadTemplateList();
  },
  methods: {
    downloadTemplateList() {
      this.axios
        .get("document-template/list", {
          params: { documentType: this.documentType }
        })
        .then(resp => {
          this.templateList = resp.data;
        });
    },
    openSaveDialog(item) {
      if (item == null) {
        this.dialogValues.id = null;
        this.dialogValues.name = "";
        this.dialogValues.public = 0;
      } else {
        this.dialogValues.id = item.id;
        this.dialogValues.name = item.name;
        this.dialogValues.public = item.public;
      }
      this.dialog = true;
    },
    remove(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      result
        .then(() => {
          this.axios.post("document-template/delete", { templateId: item.id }).then(() => {
            this.downloadTemplateList();
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.removedItem"),
              position: "down"
            });
          });
        })
        .catch(function() {});
    },
    load(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("templateList.confirmLoadDialog.content"),
        title: this.$t("templateList.confirmLoadDialog.title")
      });
      result
        .then(() => {
          this.axios.get("document-template/get?templateId=" + item.id).then(resp => {
            if (typeof this.value.delegation_order_id !== "undefined") {
              resp.data.content.delegation_order_id = this.value.delegation_order_id;
              resp.data.content.delegation_order_number = this.value.delegation_order_number;
            }
            if (this.$store.getters["userProperties"].system_settings.is_synchro_numbers === 2 && this.documentType === 1) {
              resp.data.content.custom_number = this.value.custom_number;
              resp.data.content.number = this.value.number;
            }
            this.$emit("update:value", resp.data.content);
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.loaded"),
              position: "down"
            });
          });
        })
        .catch(function() {});
    },
    save() {
      let content = JSON.parse(JSON.stringify(this.value));
      delete content.id;
      this.axios
        .post("document-template/save", {
          id: this.dialogValues.id,
          name: this.dialogValues.name,
          is_public: this.dialogValues.public,
          document_type: this.documentType,
          content: this.value
        })
        .then(() => {
          this.downloadTemplateList();
          this.dialog = false;
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped></style>
